const HTTP_METHODS = {
  POST: "POST",
  PUT: "PUT",
};

export default HTTP_METHODS;
